import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useCreateAppointmentType = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data = { title: '', order: '', isCustom: true }) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'post',
        `facility/${user.facility}/appointment-types`,
        true,
        {
          title: data.title,
          isCustom: true,
        },
      );
    },
    {
      onSuccess: async () => {
        toast('Appointment Type was successfully created', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries([cacheKeys.getAppointmentTypes()]);
      },
      onError: async (err) => {
        toast('Unable to create Appointment Type', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to create appointment type: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
